// Name an imprint location BEFORE it is created. Adding one used to save a
// placeholder called "New location" that the rep then had to rename — and
// that a supplier could see if they didn't (pilot 2026-10-13).
import { useState } from "react";
import { Button } from "@/components/ui/Button";
import { Input } from "@/components/ui/Input";

const COMMON_LOCATIONS = [
  "Front Center",
  "Full Front",
  "Left Chest",
  "Right Chest",
  "Full Back",
  "Upper Back",
  "Left Sleeve",
  "Right Sleeve",
  "Back of Neck",
  "Front of Cap",
  "Wrap",
];

export function NewLocationForm({
  pending,
  onAdd,
  onCancel,
}: {
  pending: boolean;
  onAdd: (location: string) => void;
  onCancel: () => void;
}) {
  const [name, setName] = useState("");
  const clean = name.trim();
  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (clean) onAdd(clean);
      }}
      className="mb-2 flex flex-wrap items-center gap-2"
    >
      <Input
        type="text"
        value={name}
        onChange={(e) => setName(e.target.value)}
        autoFocus
        maxLength={200}
        list="imprint-location-suggestions"
        placeholder="Where does the logo go? e.g. Left Chest"
        aria-label="Imprint location"
        className="h-8 w-64 px-2 text-xs"
      />
      <datalist id="imprint-location-suggestions">
        {COMMON_LOCATIONS.map((l) => (
          <option key={l} value={l} />
        ))}
      </datalist>
      <Button type="submit" size="sm" disabled={!clean || pending}>
        {pending ? "Adding…" : "Add location"}
      </Button>
      <Button type="button" size="sm" variant="ghost" onClick={onCancel} disabled={pending}>
        Cancel
      </Button>
    </form>
  );
}
